var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Polaris-FooterHelp"
  }, [_c('div', {
    staticClass: "Polaris-FooterHelp__Content"
  }, [_c('div', {
    staticClass: "Polaris-FooterHelp__Icon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": "help",
      "color": "teal",
      "backdrop": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Polaris-FooterHelp__Text"
  }, [_vm._t("default")], 2)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25b76f9b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25b76f9b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisFooterHelp.vue
// module id = 229
// module chunks = 0